// extracted by mini-css-extract-plugin
module.exports = {"container":"OnboardingBlock_container__GsBtd","contentWrapper":"OnboardingBlock_contentWrapper__YQmpt"};